import { SectionData } from "../_data/";

const ArticlesRoutes = [
  {
    path: "/articles",
    // name: SectionData.alias,
    routeAlias: SectionData.alias,
    title: "Artikel",
    components: {
      baseView: () =>
        import(/* webpackChunkName: "articles" */ "../views/articles.view.vue")
    },
    children: [
      {
        path: "",
        name: "articles-content",
        title: "Artikel",
        text: "Artikel",
        components: {
          contentView: () =>
            import(
              /* webpackChunkName: "articles" */ "../components/articles.component.vue"
            )
        }
      }
    ]
  }
];

export default ArticlesRoutes;
